// Ett delt tillit-hierarki for BÅDE kart-markør og plass-kort, slik at «hvor bra er
// plassen?» besvares med ETT signal i stedet for tre konkurrerende språk (menneske-
// verifisert gull-stjerne + AI-emerald + rating-tall). Presedens: menneske > AI > rating.
//
// Ren funksjon uten UI/plattform-avhengigheter → trivielt testbar. Selve fargene/formene
// bor i markøren (MapUtils) og kortet (TrustLine); denne avgjør bare HVILKET signal som vinner.

export type TrustTier = 'human' | 'ai' | 'rated' | 'none';

export interface TrustInput {
  /** Menneske-bekreftet (isVerified, brukerbidrag, bekreftet innsjekk). Høyeste presedens. */
  humanVerified?: boolean;
  /** AI-vurdert høy fricamp-egnethet (aiSuitability.suitable). Vises kun når IKKE menneske-bekreftet. */
  aiSuitable?: boolean;
  /** Beregnet stjernevurdering (bayesiansk snitt). Svakeste signal. */
  ratingAverage?: number | null;
}

/** Løser de tre tillit-språkene til ett tier med fast presedens: menneske > AI > rating. */
export function resolveTrustSignal(input: TrustInput): TrustTier {
  if (input.humanVerified) return 'human';
  if (input.aiSuitable) return 'ai';
  if (typeof input.ratingAverage === 'number' && input.ratingAverage > 0) return 'rated';
  return 'none';
}
